export const dataInf = {
  2026: [
    {
      month: "Enero",
    },
    {
      alt: "Genero",
      link: "enero_esp.jpg",
    },
    {
      alt: "Genero",
      link: "enero_nah.jpg",
    },
    {
      month: "Febrero",
    },
    {
      alt: "Usos y Costumbres",
      link: "febrero_esp.jpg",
    },
    {
      alt: "Usos y Costumbres",
      link: "febrero_nah.jpg",
    },
  ],
  2025: [
    {
      month: "Enero",
    },
    {
      alt: "Info solicitud pública",
      link: "Enero1.jpg",
    },
    {
      alt: "Info solicitud pública Nahuatl",
      link: "Enero2.jpg",
    },
    {
      month: "Febrero",
    },
    {
      alt: "Info solicitud pública",
      link: "Febrero1.jpg",
    },
    {
      alt: "Info solicitud pública Nahuatl",
      link: "Febrero2.jpg",
    },
    {
      month: "Marzo",
    },
    {
      alt: "Victima fraude",
      link: "Marzo1.webp",
    },

    {
      alt: "Victima fraude Nahuatl",
      link: "Marzo2.webp",
    },

    {
      month: "Abril",
    },
    {
      alt: "EstacionComputo",
      link: "EstacionComputo.webp",
    },
    {
      alt: "VEstacionComputo_2",
      link: "EstacionComputo_2.webp",
    },

    {
      month: "Mayo",
    },
    {
      alt: "Mayo1",
      link: "Mayo1.webp",
    },
    {
      alt: "Mayo2",
      link: "Mayo2.webp",
    },

     {
      month: "Junio",
    },
    {
      alt: "GastosCampaña1",
      link: "GastosCampaña1.webp",
    },
    {
      alt: "GastosCampaña2",
      link: "GastosCampaña2.webp",
    },

    {
      month: "Julio",
    },
    {
      alt: "UTCE",
      link: "utce_esp.png",
    },
    {
      alt: "UTCE",
      link: "utce_nah.png",
    },

    {
      month: "Agosto",
    },
    {
      alt: "UTCE",
      link: "pc_esp.png",
    },
    {
      alt: "UTCE",
      link: "pc_nah.png",
    },

    {
      month: "Septiembre",
    },
    {
      alt: "PRESIDENCIA",
      link: "pres_esp.png",
    },
    {
      alt: "PRESIDENCIA",
      link: "pres_nah.png",
    },

    {
      month: "Octubre",
    },
    {
      alt: "OFICIALIA",
      link: "ofi_esp.png",
    },
    {
      alt: "OFICIALIA",
      link: "ofi_nah.png",
    },

    {
      month: "Noviembre",
    },
    {
      alt: "JURIDICO",
      link: "daj_esp.png",
    },
    {
      alt: "JURIDICO",
      link: "daj_nah.png",
    },

    {
      month: "Diciembre",
    },
    {
      alt: "TRANSPARENCIA",
      link: "tra_esp.png",
    },
    {
      alt: "TRANSPARENCIA",
      link: "tra_nah.png",
    },
  ],
  
  2024: [
    {
      id: 1,
      month: "Marzo",
      managerId: null,
    },
    {
      alt: "Sistema Conóceles",
      link: "conoceles.jpg",
      managerId: 1,
    },
    {
      id: 2,
      month: "Septiembre",
      managerId: null,
    },
    {
      alt: "Vinculación SIVOPLE",
      link: "vinculacion.jpeg",
      managerId: 2,
    },
    {
      id: 3,
      month: "Octubre",
      managerId: null,
    },
    {
      alt: "Medios de impugnacion",
      link: "impugnacion.jpg",
      managerId: 3,
    },
  ],
  2023: [
    {
      id: 1,
      month: "Febrero",
      managerId: null,
    },
    {
      alt: "Constitución de Partidos Políticos Locales",
      link: "1.jpg",
      managerId: 1,
    },
    {
      id: 2,
      month: "Marzo",
      managerId: null,
    },
    {
      alt: "Valores de la democracia",
      link: "2.jpg",
      managerId: 2,
    },
    {
      id: 3,
      month: "Abril",
      managerId: null,
    },
    {
      alt: "Código de Ética",
      link: "3.jpg",
      managerId: 3,
    },
    {
      id: 4,
      month: "Mayo",
      managerId: null,
    },
    {
      alt: "Estudio de participación ciudadana",
      link: "7.jpg",
      managerId: 4,
    },
    {
      id: 5,
      month: "Junio",
      managerId: null,
    },
    {
      alt: "Código de Ética",
      link: "4.jpg",
      managerId: 5,
    },
    {
      id: 6,
      month: "Julio",
      managerId: null,
    },
    {
      alt: "¿Qué son los partidos politicos?",
      link: "5.jpg",
      managerId: 6,
    },
    {
      id: 7,
      month: "Septiembre",
      managerId: null,
    },
    {
      alt: "Proceso de verificación trianual",
      link: "6.jpg",
      managerId: 7,
    },

  ],
  2022: [
    {
      id: 1,
      month: "Enero",
      managerId: null,
    },
    {
      alt: "Infografia Nahualt",
      link: "1.jpeg",
      managerId: 1,
    },
    {
      alt: "Avisos de privacidad",
      link: "2.jpeg",
      managerId: 1,
    },
    {
      id: 2,
      month: "Febrero",
      managerId: null,
    },
    {
      alt: "Constitución de Partidos Políticos Locales",
      link: "3.jpg",
      managerId: 2,
    },
    {
      alt: "Plebiscito 1",
      link: "4.jpeg",
      managerId: 2,
    },
    {
      alt: "Plebiscito 2",
      link: "5.jpeg",
      managerId: 2,
    },
    {
      alt: "¿Como nos identificamos'",
      link: "6.jpeg",
      managerId: 2,
    },
    {
      alt: "Infografía 1",
      link: "7.jpeg",
      managerId: 2,
    },
    {
      id: 3,
      month: "Marzo",
      managerId: null,
    },
    {
      alt: "Sesiones de Consejo General",
      link: "8.jpg",
      managerId: 3,
    },
    {
      id: 4,
      month: "Junio",
      managerId: null,
    },
    {
      alt: "Día Nacional de la Lengua de Señas Mexicana",
      link: "9.jpg",
      managerId: 4,
    },
    {
      id: 5,
      month: "Julio",
      managerId: null,
    },
    {
      alt: "Voz ciudadana en el cabildo",
      link: "10.jpg",
      managerId: 5,
    },
  ],
  2021: [
    {
      id: 1,
      month: "Enero",
      managerId: null,
    },
    {
      alt: "Transparencia",
      link: "1.jpg",
      managerId: 1,
    },
    {
      id: 2,
      month: "Febrero",
      managerId: null,
    },
    {
      alt: "Infografia 1",
      link: "2.jpg",
      managerId: 2,
    },
    {
      alt: "Infografía 2",
      link: "3.jpg",
      managerId: 2,
    },
    {
      id: 3,
      month: "Marzo",
      managerId: null,
    },
    {
      alt: "Dirección de Asuntos Jurídicos",
      link: "4.jpg",
      managerId: 3,
    },
    {
      alt: "Contraloría General del ITE",
      link: "5.jpeg",
      managerId: 3,
    },
    {
      id: 4,
      month: "Abril",
      managerId: null,
    },
    {
      alt: "Derechos ARCO",
      link: "6.jpg",
      managerId: 4,
    },
    {
      alt: "Medidas sanitarias para el voto seguro",
      link: "7.jpg",
      managerId: 4,
    },
    {
      alt: "Referéndum",
      link: "8.jpeg",
      managerId: 4,
    },
    {
      alt: "Referéndum Nahuatl",
      link: "9.jpeg",
      managerId: 4,
    },
    {
      alt: "Referéndum",
      link: "10.jpeg",
      managerId: 4,
    },
    {
      alt: "Referéndum Nahuatl",
      link: "11.jpeg",
      managerId: 4,
    },
    {
      id: 5,
      month: "Mayo",
      managerId: null,
    },
    {
      alt: "Datos PREP",
      link: "12.jpg",
      managerId: 5,
    },
    {
      alt: "Referendum",
      link: "13.jpeg",
      managerId: 5,
    },
    {
      alt: "Referendum Nahualt",
      link: "14.jpeg",
      managerId: 5,
    },
    {
      id: 6,
      month: "Junio",
      managerId: null,
    },
    {
      alt: "Proceso Electoral Local Ordinario 2020-2021",
      link: "15.jpeg",
      managerId: 6,
    },
    {
      id: 7,
      month: "Julio",
      managerId: null,
    },
    {
      alt: "Proceso Electoral Local Ordinario 2020-2021 Medios de Comunicación",
      link: "16.png",
      managerId: 7,
    },
    {
      alt: "Plebiscito Nahualt",
      link: "17.png",
      managerId: 7,
    },
    {
      id: 8,
      month: "Agosto",
      managerId: null,
    },
    {
      alt: "Financiamiento Público",
      link: "18.jpg",
      managerId: 8,
    },
    {
      alt: "Plebiscito Nahualt",
      link: "19.png",
      managerId: 8,
    },
    {
      id: 10,
      month: "Octubre",
      managerId: null,
    },
    {
      alt: "Secretaría Ejecutiva",
      link: "20.jpg",
      managerId: 10,
    },
    {
      alt: "Etapas de un Documento de Archivo",
      link: "21.jpg",
      managerId: 10,
    },
    {
      alt: "Acervo Documental",
      link: "22.jpg",
      managerId: 10,
    },
    {
      alt: "Ciclo vital de un documento",
      link: "23.jpg",
      managerId: 10,
    },
    {
      id: 11,
      month: "Noviembre",
      managerId: null,
    },
    {
      alt: "Violencia Política Contral las Mujeres en Razón de Género",
      link: "24.jpg",
      managerId: 11,
    },
    {
      alt: "Violencia Política",
      link: "25.jpg",
      managerId: 11,
    },
  ],
  2020: [
    {
      id: 1,
      month: "Enero",
      managerId: null,
    },
    {
      alt: "Día de la No Violencia Escolar",
      link: "1.jpg",
      managerId: 1,
    },
    {
      id: 2,
      month: "Febrero",
      managerId: null,
    },
    {
      alt: "Información Procesos Electorales",
      link: "2.jpg",
      managerId: 2,
    },
    {
      id: 3,
      month: "Marzo",
      managerId: null,
    },
    {
      alt: "Contraloría General del ITE LIPEET Artpiculo 85",
      link: "3.jpg",
      managerId: 3,
    },
    {
      id: 4,
      month: "Abril",
      managerId: null,
    },
    {
      alt: "Infografía Nahualt 1",
      link: "4.jpg",
      managerId: 4,
    },
    {
      alt: "Infografía Nahualt 2",
      link: "5.jpg",
      managerId: 4,
    },
    {
      alt: "Atribuciones del Titular del Área Técnica de Informática",
      link: "6.jpg",
      managerId: 4,
    },
    {
      id: 5,
      month: "Mayo",
      managerId: null,
    },
    {
      alt: "Información Proceso Electoral 2021",
      link: "7.jpg",
      managerId: 5,
    },
    {
      id: 6,
      month: "Junio",
      managerId: null,
    },
    {
      alt: "Oficialía Electoral",
      link: "8.jpg",
      managerId: 6,
    },
    {
      id: 7,
      month: "Julio",
      managerId: null,
    },
    {
      alt: "Datos Personales",
      link: "9.jpg",
      managerId: 7,
    },
    {
      alt: "Micrositio COVID",
      link: "10.jpeg",
      managerId: 7,
    },
    {
      id: 8,
      month: "Agosto",
      managerId: null,
    },
    {
      alt: "Que hace la Presidencia del ITE",
      link: "11.jpg",
      managerId: 8,
    },
    {
      alt: "Que funciones tiene la Presidencia del ITE",
      link: "12.jpg",
      managerId: 8,
    },
    {
      id: 9,
      month: "Septiembre",
      managerId: null,
    },
    {
      alt: "Atribuciones de Prerrogativas, Administración y Fiscalización",
      link: "13.jpg",
      managerId: 9,
    },
    {
      id: 10,
      month: "Octubre",
      managerId: null,
    },
    {
      alt: "Datos Personales Nahualt 1",
      link: "14.jpg",
      managerId: 10,
    },
    {
      alt: "Datos Personales Nahualt 2",
      link: "15.jpg",
      managerId: 10,
    },
    {
      alt: "Día Internacional de la No Violencia",
      link: "16.jpg",
      managerId: 10,
    },
    {
      alt: "Atribuciones de la Dirección de Asuntos Jurídicos",
      link: "17.jpg",
      managerId: 10,
    },
    {
      id: 11,
      month: "Noviembre",
      managerId: null,
    },
    {
      alt: "Integración del COTAPREP",
      link: "18.jpg",
      managerId: 11,
    },
    {
      alt: "Datos Proceso Electoral Local Ordinario 2020 - 2021",
      link: "19.jpg",
      managerId: 11,
    },
    {
      alt: "Vota, tú decides",
      link: "20.jpg",
      managerId: 11,
    },
    {
      id: 12,
      month: "Diciembre",
      managerId: null,
    },
    {
      alt: "Día Internacional de las personas con discapacidad",
      link: "21.jpg",
      managerId: 12,
    },
    {
      alt: "Manifestaciones de intención",
      link: "22.jpg",
      managerId: 12,
    },
    {
      alt: "Manifestaciones de intención aprobadas",
      link: "23.jpg",
      managerId: 12,
    },
    {
      alt: "Día internacional de los derechos humanos",
      link: "24.jpg",
      managerId: 12,
    },
  ],
};
